exports.version = "2.4.5"


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/apollo-client/version.js
// module id = 7dO1
// module chunks = 20